import { defineComponent as _defineComponent } from 'vue'

// eslint-disable-next-line import/extensions,import/no-unresolved
import { defaultSubscriptions, Subscription } from '@/foundations/helpers/defaultSubscriptions';
// eslint-disable-next-line import/extensions,import/no-unresolved
import { defaultRealms, Realm } from '@/foundations/helpers/defaultRealms';

type Props = {
  title: string;
  resource: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  resource: any;
}



const fields = [
  {
    source: 'id',
    link: 'edit',
    sortable: false,
  },
  {
    source: 'realm',
    label: 'Market',
    sortable: false,
    type: 'chip',
    attributes: {
      color: 'orange',
    },
  },
  {
    source: 'key',
    label: 'Subscription',
    sortable: true,
  },
  {
    source: 'properties.lang',
    label: 'Language',
    sortable: false,
  }
];

const filters = [
  {
    source: 'key',
    label: 'Subscription',
    type: 'autocomplete',
    attributes: {
      multiple: true,
      choices: defaultSubscriptions,
      itemText: (item: Subscription) => item.subscription,
      minChars: 1000,
    },
  },
  {
    source: 'realm',
    label: 'Market',
    type: 'autocomplete',
    attributes: {
      multiple: true,
      choices: defaultRealms,
      itemText: (item: Realm) => item.realm,
      itemValue: (item: Realm) => item.code,
      minChars: 1000,
    },
  },
];
const filter = {};

return { __sfc: true,props, fields, filters, filter }
}

})